import React from 'react';
import { connect } from 'react-redux';
import { RemoteVideoMenuTriggerButton, _connect } from './RemoteVideoMenuTriggerButton';

import {
    MuteButton,
    MuteVideoButton,
    KickButton,
    PrivateMessageMenuButton,
    VideoMenu
} from './';
import { IconRaiseHand } from '../../../base/icons';
import { getLocalParticipant, getParticipantById, PARTICIPANT_ROLE } from '../../../base/participants';

class RPC_RemoteVideoMenuTriggerButton extends RemoteVideoMenuTriggerButton {
    constructor(props) {
        super(props);
        this.lowerHand = this.lowerHand.bind(this);
    }

    lowerHand() {
        const {
            participantID
        } = this.props;
        APP.conference.sendEndpointMessage(participantID, {
            lowerHand: true
        })
    }

    _renderRemoteVideoMenu() {
        const {
            _disableKick,
            _disableRemoteMute,
            _isModerator,
            _raisedHand,
            participantID
        } = this.props;

        const buttons = [];

        if(_isModerator) {
            if (!_disableRemoteMute) {
                buttons.push(
                    <MuteButton
                        key = 'mute'
                        participantID = { participantID } />
                );
            }

            if(_raisedHand) {
                buttons.push(
                    <li className = 'popupmenu__item'>
                        <a
                            className = { 'popupmenu__link' }
                            id = { 'mutelink_'+participantID }
                            onClick = { this.lowerHand }>
                            <span className = 'popupmenu__icon'>
                                <IconRaiseHand />
                            </span>
                            <span className = 'popupmenu__text'>
                                Lower Hand
                            </span>
                        </a>
                    </li>
                );
            }

            if (!_disableKick) {
                buttons.push(
                    <KickButton
                        key = 'kick'
                        participantID = { participantID } />
                );
            }
        }

        buttons.push(
            <PrivateMessageMenuButton
                key = 'privateMessage'
                participantID = { participantID } />
        );

        if (buttons.length > 0) {
            return (
                <VideoMenu id = { participantID }>
                    { buttons }
                </VideoMenu>
            );
        }
    }

}

function _mapStateToProps(state, ownProps) {
    const { participantID } = ownProps;
    const participant = getParticipantById(state, participantID);
    const localParticipant = getLocalParticipant(state);
    return {
        _isModerator: Boolean(localParticipant?.role === PARTICIPANT_ROLE.MODERATOR),
        _raisedHand: participant.raisedHand
    };
}

export default _connect(connect(_mapStateToProps)(RPC_RemoteVideoMenuTriggerButton))